import { TRootState } from 'Redux/Reducers';

export const checkUserRole = (roles: string[]) => (state: TRootState) => {
  const { user } = state;
  if (user.currentUser && user.currentUser.role) {
    return roles.includes(user.currentUser.role);
  }
  return false;
};
